import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  template: `
    <footer class="bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-slate-400 px-6 py-3 flex justify-between items-center text-sm border-t dark:border-slate-700 flex-shrink-0">
      <span>v{{ version }}</span>
      <span>Call Avoidance Search</span>
    </footer>
  `
})
export class FooterComponent {
  version = environment.version;
}
